<script>

    import { createEventDispatcher } from 'svelte'
    import { toast } from 'bulma-toast'
    import { TicketStore, TicketsStore } from '../stores'

    import TicketsService from '../$services/tickets.service'

    import FileUpload from '../$components/file.upload.svelte'
    import Form from '../$components/form.svelte'

    const dispatch = createEventDispatcher()

    export let label = 'Documento'
    export let fieldName = 'Documento'

    let loading = false
    let data = {}

    async function updateTicket() {

        data[`${fieldName}Document`] = data.invoiceDocument

        loading = true
        const resp = await TicketsService.updateTicket($TicketStore._id, data)
        loading = false

        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})

        TicketsStore.replace(resp.data)
        TicketStore.set(resp.data)

        toast({message: 'Ticket actualizado', type: 'is-success'})
        dispatch('updated', resp.data)
    }

</script>

{#if $TicketStore}
    <Form on:submit={updateTicket} on:canceled { loading } >
        <div class="columns">
            <div class="column">
                <FileUpload bind:url={data.invoiceDocument} label={label} fileDir={ `/tickets/${ $TicketStore._id }/${ fieldName }` } accept=".pdf" />
            </div>
        </div>
    </Form>
{/if}